import { enhancedApi } from '@store/generated/transcription';

/**
 * Feature-specific tag types for transcription
 * Note: This API is primarily for upload/streaming operations, not list-based
 */
const TRANSCRIPTION_TAG_TYPES = ['TranscriptionSession'] as const;

/**
 * Transcription API - extends the generated API with custom tagging
 *
 * This API handles:
 * - Realtime streaming session creation
 * - Upload URL generation (S3 presigned URLs)
 * - Test upload URLs
 * - Proxy uploads
 */
export const transcriptionApi = enhancedApi.enhanceEndpoints({
  addTagTypes: TRANSCRIPTION_TAG_TYPES,
  endpoints: {
    // Note: These are mutation-only endpoints (no cache tags needed)
    // Add invalidation tags if/when GET endpoints are added
  },
});

// Export hooks with user-friendly names
export const {
  usePostV2ProviderTranscriptionsRealtimeSessionMutation: useCreateRealtimeSessionMutation,
  usePostV2ProviderTranscriptionsUploadUrlMutation: useCreateUploadUrlMutation,
  usePostV2ProviderTranscriptionsTestUploadUrlMutation: useCreateTestUploadUrlMutation,
  usePostV2ProviderTranscriptionsProxyUploadMutation: useProxyUploadMutation,
} = transcriptionApi;
